import { safeJsonParse } from "./Json";
import { getDeviceFamilyFromId } from "./DevicePresence";

//Zone breadcrumbs arrive as a pipe separated path, the same shape the report chart renders.
const ZONE_SEPARATOR = "|";
const ZONE_LABEL_SEPARATOR = " > ";

//Fixed so the picker does not reorder itself as devices are added to a scheme.
const FAMILY_ORDER = ["CC", "FS2"];

const getZonePath = (device) => {
	//zoneBreadcrumb reaches us as the raw JSON string from the API, or already parsed when the
	//devices list came from devicesListSelector. safeJsonParse passes an object straight through.
	const breadcrumb = safeJsonParse(device?.zoneBreadcrumb, null, "zoneBreadcrumb");
	const label = typeof breadcrumb?.label === "string" ? breadcrumb.label.trim() : "";
	return label || null;
};

//Groups a scheme's devices the two ways a report is usually scoped: by device family, and by
//zone. A zone group holds every device in that zone and in the zones under it, so picking a
//zone near the top of a site narrows a report to that part of the site in one click.
export const buildDeviceGroups = (devices) => {
	const list = Array.isArray(devices) ? devices.filter((device) => device?.id) : [];

	const byFamily = new Map();
	const byZone = new Map();

	const addTo = (map, key, device) => {
		if (!map.has(key)) map.set(key, []);
		map.get(key).push(device);
	};

	list.forEach((device) => {
		const family = getDeviceFamilyFromId(device.id);
		if (family) addTo(byFamily, family, device);

		const path = getZonePath(device);
		if (!path) return;

		//The device counts towards its own zone and towards every zone above it, which is what
		//makes a parent zone select the whole subtree.
		const segments = path.split(ZONE_SEPARATOR).filter(Boolean);
		segments.forEach((_, idx) => addTo(byZone, segments.slice(0, idx + 1).join(ZONE_SEPARATOR), device));
	});

	const types = FAMILY_ORDER.filter((family) => byFamily.has(family)).map((family) => ({
		family,
		devices: byFamily.get(family),
	}));

	//A plain string sort puts a parent immediately before its children, since a parent path is
	//a prefix of every path below it.
	const zones = [...byZone.keys()].sort().map((path) => ({
		path,
		label: path.split(ZONE_SEPARATOR).join(ZONE_LABEL_SEPARATOR),
		devices: byZone.get(path),
	}));

	return { types, zones };
};
